<template>
  <div>
    测试页面12
    <div style="border: 1px solid red; height: 100px">
      <el-empty description="暂无回访图片" />
    </div>
  </div>
</template>
<script>
import ArchivesModuleView from "../components/datav/ArchivesModuleView.vue";
import MAPDATA from "../assets/map/dadukou.json";
export default {
  components: {
    ArchivesModuleView,
  },
  data() {
    return {};
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    initMap(geoData) {
      this.$nextTick(() => {
        var map = new AMap.Map("mapScreen", {
          center: [106.48613, 29.481002],
          zoom: 12.5,
          zooms: [11, 30],
          expandZoomRange: false,
          mapStyle: "amap://styles/darkblue",
          showbiz: true,
        });
        //map.setZoom(12.2); //设置地图层级
        new AMap.DistrictSearch({
          extensions: "all",
          subdistrict: 0,
        }).search("大渡口", function (status, result) {
          console.log(result);

          // 外多边形坐标数组和内多边形坐标数组
          var outer = [
            new AMap.LngLat(-360, 90, true),
            new AMap.LngLat(-360, -90, true),
            new AMap.LngLat(360, -90, true),
            new AMap.LngLat(360, 90, true),
          ];
          var holes = result.districtList[0].boundaries;
          console.log(result.districtList[0]);
          var pathArray = [outer];
          pathArray.push.apply(pathArray, holes);
          var polygon = new AMap.Polygon({
            pathL: pathArray,
            //线条颜色，使用16进制颜色代码赋值。默认值为#006600
            strokeColor: "rgb(20,164,173)",
            strokeWeight: 4,
            //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            strokeOpacity: 0.5,
            //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
            fillColor: "rgba(0,0,0)",
            //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            fillOpacity: 1,
            //轮廓线样式，实线:solid，虚线:dashed
            strokeStyle: "dashed",
            /*勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效， 此属性在
              ie9+浏览器有效 取值：
              实线：[0,0,0]
              虚线：[10,10] ，[10,10] 表示10个像素的实线和10个像素的空白（如此反复）组成的虚线
              点画线：[10,2,10]， [10,2,10] 表示10个像素的实线和2个像素的空白 + 10个像素的实
              线和10个像素的空白 （如此反复）组成的虚线*/
            strokeDasharray: [10, 2, 10],
          });
          polygon.setPath(pathArray);
          map.add(polygon);
        });
        this.test(map, geoData);

        map.on("click", function (ev) {
          console.log(ev);
          // 触发事件的对象
          var target = ev.target;
          // 触发事件的地理坐标，AMap.LngLat 类型
          var lnglat = ev.lnglat;
          // 触发事件的像素坐标，AMap.Pixel 类型
          var pixel = ev.pixel;
          // 触发事件类型
          var type = ev.type;
        });
      });
    },
    test(map, geoData) {
      let that = this;
      if (map) {
        map.clearMap();
        //https://developer.amap.com/demo/javascript-api/example/overlayers/geojson
        var texts = {};
        console.log("texts", MAPDATA);
        var mapGeo = new AMap.GeoJSON({
          geoJSON: geoData || MAPDATA,
          getPolygon: function (json, lnglats) {
            if (json.properties.id == -4603) {
              return; //南海诸岛
            }
            var pol = new AMap.Polygon({
              path: lnglats,
              bubble: true, //事件冒泡
              strokeWeight: 1,
              strokeColor: "#0091ea",
              fillColor: "#80d8ff",
              fillOpacity: 0.3,
            });

            if (lnglats.length) {
              var prop = json.properties;

              prop = prop._parentProperities || prop;
              console.log(prop);
              var obj = texts[prop.unique_id] || { pols: [] };
              obj.name = prop.name;
              obj.data = prop;
              obj.pols.push({
                pos: pol.getBounds().getCenter(),
                size: pol.getArea(),
                pol: pol,
              });
              texts[prop.unique_id] = obj;
            }

            return pol;
          },
        });
        map.add(mapGeo);

        console.log("texts", texts);
        //显示名称
        for (var k in texts) {
          (function () {
            var o = texts[k];
            o.pols.sort(function (a, b) {
              return b.size - a.size;
            });
            var center = o.pols[0].pos,
              dCP = o.data.cp; //指定了名字显示坐标
            if (dCP && dCP.splice && +dCP[0] && +dCP[1]) {
              center = new AMap.LngLat(+dCP[0], +dCP[1]);
            }
            var txt = new AMap.Text({
              map: map,
              bubble: true, //事件冒泡
              text: o.name,
              position: center,
              style: {
                color: "#06c",
                border: "none",
                background: "none",
                fontSize: "14px",
              },
              extData: o.data,
            });
            txt.on("click", (e) => {
              if (window.mapDistanceIsOpen) return;
              var o = e.target.getExtData();
              console.log("amap click", o);
              let features = MAPDATA.features;
              features = features.filter(
                (v) => v.properties.unique_id == o.unique_id
              );
            });
            txt.on("mouseover", function () {
              console.log("执行成功");

              if (window.mapDistanceIsOpen) return;
              txt.setStyle({ color: "#fa0" });
              for (var i = 0; i < o.pols.length && i < 10; i++) {
                //只高亮前面最大的几个图形 其他小的忽略 提高性能
                o.pols[i].pol.setOptions({
                  fillColor: "#0091ea",
                  fillOpacity: 1,
                });
              }
            });
            txt.on("mouseout", function () {
              console.log("执行成功");
              txt.setStyle({ color: "#06c" });
              for (var i = 0; i < o.pols.length && i < 10; i++) {
                o.pols[i].pol.setOptions({
                  fillColor: "#80d8ff",
                  fillOpacity: 0.3,
                });
              }
            });
            // map.add(lnglats);
          })();
        }
        map.setFitView();
      }
    },
  },
};
</script>
<style scoped lang="less">
#mapScreen {
  height: 1000px;
}
</style>
